
import { Box, Typography, Avatar, Container } from "@mui/material"
import FormatQuoteIcon from "@mui/icons-material/FormatQuote"
import worldMapBackground from "../../../assets/images/map.png"
import avatar from "../../../assets/images/Avatar-7.png"

// Sample testimonial data
const testimonial = {
  quote:
    "Thanks to this platform, I finally landed a role that truly aligns with my skills and career goals. They don’t just connect you to companies,they match you with the right opportunities. My job search ended the moment I found them.",
  name: "Gloria Jessica",
  avatar: avatar, 
}

function TestimonialSection() {
  // const theme = useTheme()
  // const isMobile = useMediaQuery(theme.breakpoints.down("md"))

  return (
    <Container
      maxWidth={false}
      sx={{
        position: "relative",
        padding: { xs: "40px 20px", md: "60px 80px" },
        overflow: "hidden",
        minHeight: "600px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        backgroundColor: "#FAFAFA",
      }}
    >
      {/* Background World Map */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url(${worldMapBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.7,
          zIndex: 0,
        }}
      />

      {/* Content */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        {/* Section Title */}
        <Box sx={{ mb: 4 }}>
          <Box
            sx={{
              width: "60px",
              height: "4px",
              backgroundColor: "#D81B60",
              mb: 2,
            }}
          />
          <Typography
            variant="h6"
            sx={{
              color: "#666",
              fontWeight: 400,
              mb: 2,
            }}
          >
            Testimonials
          </Typography>
          <Typography
            variant="h3"
            component="h2"
            sx={{
              fontWeight: 700,
              fontSize: { xs: "28px", md: "36px" },
              maxWidth: "600px",
              color: "#333",
            }}
          >
            Hear from our client & Talents
          </Typography>
        </Box>

        {/* Testimonial Card - Reduced margin-top to move it up */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            mt: { xs: -4, md: -8 }, // Reduced from mt: { xs: 4, md: 8 }
          }}
        >
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: "8px",
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
              p: { xs: 3, md: 5 },
              maxWidth: { xs: "100%", md: "550px" },
              position: "relative",
            }}
          >
            <FormatQuoteIcon
              sx={{
                color: "#D81B60",
                fontSize: "40px",
                mb: 2,
              }}
            />
            <Typography
              variant="body1"
              sx={{
                color: "#666",
                mb: 4,
                lineHeight: 1.6,
              }}
            >
              {testimonial.quote}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Avatar
                src={testimonial.avatar}
                alt={testimonial.name}
                sx={{
                  width: 56,
                  height: 56,
                  mr: 2,
                  border: "2px solid #f5f5f5",
                }}
              />
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  color: "#333",
                }}
              >
                {testimonial.name}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  )
}

export default TestimonialSection

